import { createFileRoute } from "@tanstack/react-router";
import AuthRefreshPage from "@/app/auth/refresh/page";

export const Route = createFileRoute("/auth/refresh")({
  component: AuthRefreshPage,
});
